import computed from './attrs/computed'
import methods from './attrs/methods'

export default {
    name: 'Header',
    computed,
    methods
}